<template>
<div class="w-100 h-100">
  <swiper id="home-swiper" :options="isMobile().any? swiperOptionMobile: swiperOptionPC" ref="homeSwiper" @slide-change-transition-start="updatePage">
    <swiper-slide class="slider-item-1" :data-hash="'top'">
      <div class="bg-mobile bg-cover" :style="{backgroundImage: 'url('+ bgMobile +')'}">
        <div class="d-flex justify-content-center align-items-center h-100" style="width: 100vw;">
          <img src="@/assets/images/logo-white.svg">
        </div>
        <div class="arrow-right text-white">
          scroll&emsp;<img src="@/assets/images/arrow-right.svg">
        </div>
      </div>
      <div class="bg-1-2">
        <div class="bg1 d-flex justify-content-center align-items-center" :style="{backgroundImage: 'url('+ bgImage(1, true) +')'}">
          <img src="@/assets/images/logo-white.svg">
          <div class="arrow-right text-white h5 tracking-1">
            scroll&emsp;<img src="@/assets/images/arrow-right.svg">
          </div>
        </div>
        <div class="bg2" :style="{backgroundImage: 'url('+ bgImage(1, false) +')'}">
        </div>
      </div>
    </swiper-slide>
    <swiper-slide :data-hash="'concept'">
      <div class="d-md-flex justify-content-center align-items-center w-100 h-100 px-3">
        <div class="pt-6 pt-md-0 pl-6 pl-md-0 text-md-center text-white">
          <h2 class="d-none d-md-block font-size-2_5rem tracking-1 mb-5">CONCEPT</h2>
          <p class="line-height-2">
            「香りを経験し、嗅覚で楽しむ場所」をコンセプトに2018年11月オープンしたフレグランス専門店。<br>
            香水初心者から愛好家の方まで「香りが好き、興味がある」という方はどなたでも気軽に香りをお試しいただける空間です。<br>
            どのような香りが存在するのか、そもそも自分が好きな香りはどのようなものなのか、<br>
            といったことを知っていただける機会と場を提供したいと考えています。<br>
            美味しい食事やお酒を楽しむ、音楽を聴く、舞台を観る、素晴らしい芸術作品を鑑賞するといったことと同様に、<br>
            香りの世界を楽しんでいただきたいと考えております。
          </p>
          <p class="line-height-2 d-none d-md-block">
            【落ち着いた空間で本当にお気に入りと出会う】<br>
            時間の許す限りゆっくり試していただきたいという考えから、カウンター席と無料のドリンクを御用意しております。<br>
            香りの好みやお探しの系統などをお伺いしながら、様々な香りを世界観やストーリーとともにご紹介いたします。<br>
            選び方から使い方までお気軽にご相談ください。<br>
            オーナーは「ATELIERS AROMES &amp; PARFUMS PARIS/アトリエ・アローム＆パルファン・パリ(※)」にて、<br>
            調香の基礎や香料の知識、香水の歴史や名香などについて学んだ大の香り好きです。
          </p>
        </div>
      </div>
      <h2 class="d-md-none mobile-section-title text-white">CONCEPT</h2>
    </swiper-slide>
    <swiper-slide :data-hash="'news'"><News /></swiper-slide>
    <swiper-slide :data-hash="'brand'"><Brands /></swiper-slide>
    <swiper-slide :data-hash="'type'"><TypeNotes /></swiper-slide>
    <swiper-slide :data-hash="'library'"><Libraries /></swiper-slide>
    <swiper-slide :data-hash="'information'"><Information /></swiper-slide>
    <swiper-slide :data-hash="'reservation'"><Reservation /></swiper-slide>
    <swiper-slide :data-hash="'onlinestore'"><OnlineShop /></swiper-slide>
  </swiper>
  <a href="https://www.instagram.com/lesillage_kyoto/" target="_blank" class="btn btn-instagram d-none d-md-inline-block" :class="btnClass">
    <font-awesome-icon :icon="['fab', 'instagram']" />
  </a>
</div>
</template>

<script>
import isMobile from 'ismobilejs'
import bg1l from '@/assets/images/bg/1-l.jpg'
import bg1r from '@/assets/images/bg/1-r.jpg'
import bg1l2x from '@/assets/images/bg/1-l@2x.jpg'
import bg1r2x from '@/assets/images/bg/1-r@2x.jpg'
import bg2l from '@/assets/images/bg/2-l.jpg'
import bg2r from '@/assets/images/bg/2-r.jpg'
import bg2l2x from '@/assets/images/bg/2-l@2x.jpg'
import bg2r2x from '@/assets/images/bg/2-r@2x.jpg'
import bg3l from '@/assets/images/bg/3-l.jpg'
import bg3r from '@/assets/images/bg/3-r.jpg'
import bg3l2x from '@/assets/images/bg/3-l@2x.jpg'
import bg3r2x from '@/assets/images/bg/3-r@2x.jpg'
import bg4l from '@/assets/images/bg/4-l.jpg'
import bg4r from '@/assets/images/bg/4-r.jpg'
import bg4l2x from '@/assets/images/bg/4-l@2x.jpg'
import bg4r2x from '@/assets/images/bg/4-r@2x.jpg'
import bg1Mobile from '@/assets/images/bg/1@xs.jpg'
import bg2Mobile from '@/assets/images/bg/2@xs.jpg'
import bg3Mobile from '@/assets/images/bg/3@xs.jpg'
import bg4Mobile from '@/assets/images/bg/4@xs.jpg'
import News from '@/components/News'
import Brands from '@/components/Brands'
import TypeNotes from '@/components/TypeNotes'
import Libraries from '@/components/Libraries'
import Information from '@/components/Information'
import OnlineShop from '@/components/OnlineShop'
import Reservation from '@/components/Reservation'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    News, Information, OnlineShop, Reservation, Brands, TypeNotes,Libraries
  },
  data() {
    return {
      bgNumber: 0,
      isMobile,
      bg1l: bg1l,
      bg1r: bg1r,
      bg1Mobile: bg1Mobile,
      swiperOptionPC: {
        direction: 'horizontal',
        slidesPerView: 1,
        speed: 600,
        spaceBetween: 0,
        mousewheel: true,
        allowTouchMove: false,
        hashNavigation: {
          replaceState: true
        }
      },
      swiperOptionMobile: {
        direction: 'horizontal',
        slidesPerView: 1,
        speed: 600,
        spaceBetween: 0,
        mousewheel: false,
        hashNavigation: {
          replaceState: true
        }
      }
    }
  },
  created() {
    let hash = location.hash
    console.log(hash)
    if (hash) {
      if (hash == '#concept') {
        this.storePage(1)
      } else if (hash == '#news') {
        this.storePage(2)
      } else if (hash == '#brand') {
        this.storePage(3)
      } else if (hash == '#type') {
        this.storePage(4)
      } else if (hash == '#library') {
        this.storePage(5)
      } else if (hash == '#information') {
        this.storePage(6)
      } else if (hash == '#reservation') {
        this.storePage(7)
      } else if (hash == '#onlinestore') {
        this.storePage(8)
      } else {
        this.storePage(0)        
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      currentPage: state => state.currentPage
    }),
    btnClass() {
      if (2 <= this.currentPage && this.currentPage <= 6) {
        return ''
      } else {
        return 'white'
      }
    },
    bgMobile() {
      let rand = Math.random()
      if (rand < 0.25) {
        return bg1Mobile
      } else if (rand < 0.5) {
        return bg2Mobile
      } else if (rand < 0.75) {
        return bg3Mobile
      }
      return bg4Mobile
    }
  },
  watch: {
    currentPage(to, from) {
      if (to != from) {
        this.scrollTo(to)
      }
    }
  },
  methods: {
    bgImage(index, isLeft) {
      if (this.bgNumber < 1) {
        this.bgNumber = Math.floor( Math.random() * (4 + 1 - 1) ) + 1 ;
      }
      if (isLeft) {
        if (window.innerWidth > 1440 || window.devicePixelRatio > 1) {
          if (this.bgNumber == 1) {
            return bg1l2x
          } else if (this.bgNumber == 2) {
            return bg2l2x
          } else if (this.bgNumber == 3) {
            return bg3l2x            
          } else {
            return bg4l2x
          }
        } else {
          if (this.bgNumber == 1) {
            return bg1l
          } else if (this.bgNumber == 2) {
            return bg2l
          } else if (this.bgNumber == 3) {
            return bg3l            
          } else {
            return bg4l
          }
        }
      } else {
        if (window.innerWidth > 1440 || window.devicepixelratio > 1) {
          if (this.bgNumber == 1) {
            return bg1r2x
          } else if (this.bgNumber == 2) {
            return bg2r2x
          } else if (this.bgNumber == 3) {
            return bg3r2x            
          } else {
            return bg4r2x
          }
        } else {
          if (this.bgNumber == 1) {
            return bg1r
          } else if (this.bgNumber == 2) {
            return bg2r
          } else if (this.bgNumber == 3) {
            return bg3r
          } else {
            return bg4r
          }
        }
      }
    },
    updatePage() {
      this.storePage(this.$refs.homeSwiper.$swiper.activeIndex)
    },
    ...mapActions({
      storePage: 'doSetPage'
    }),
    scrollTo(index) {
      this.$refs.homeSwiper.$swiper.slideTo(index, 1000, false)
    }
  }
}
</script>

<style lang="scss">
#home-swiper {
  height: 100%;
  .slider-item-1 {
    .bg-mobile {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 0;
      height: 100%;
      width: 300%;
      @media screen and (min-width: 768px){
        display: none;
      }
      .arrow-right {
        position: absolute;
        bottom: 20px;
        left: 60vw;
        width: 120px;
        margin-bottom: 10px;
      }
    }
    .bg-1-2 {
      display: none;
      @media screen and (min-width: 768px){
        display: block;
      }
      position: relative;
      width: 100%;
      height: 100%;
      .bg1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: right;
        .arrow-right {
          position: absolute;
          bottom: 20px;
          right: 60px;
          width: 130px;
          margin-bottom: 10px;
        }
      }
      .bg2 {
        position: absolute;
        top: 0;
        left: 100%;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: left;
      }
    }
  }
}
.btn-instagram {
  position: fixed;
  bottom: 15px;
  left: 15px;
  z-index: 2;
  color: #333;
  font-size: 1.5rem !important;
  &.white {
    color: #fff;
  }
  &:hover {
    &.white {
      color: #aaa;
    }
  }
}
.btn-bottle {
  position: fixed;
  top: 30px;
  left: 30px;
  z-index: 2;
}
</style>